import React, { useContext } from 'react';
import { Modal } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import DeviceOrgTable from '@totem/components/devices/devicesContainer/DeviceOrgTable';
import DevicesContainer, {
  containerConfiguration,
} from '@totem/components/devices/devicesContainer/DevicesContainer';
import softwareContext from '@totem/components/software/software_report/softwareContext';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { Filter } from '@totem/types/common';
import { DeviceQueryResult } from '@totem/types/devices';
import { isNotNull } from '@totem/utilities/common';
import {
  DEVICES_CROSS_ORG_PAGINATION_ENDPOINT,
  SOFTWARE_WHERE_FOUND_ENDPOINT,
} from '@totem/utilities/endpoints';

type Props = {
  open: boolean;
};

const DialogSoftwareWhereFound = ({ open }: Props) => {
  const { selectedPackages, onAction } = useContext(softwareContext);
  const selectedPackageIds = selectedPackages.map((pkg) => pkg.id);

  const staticFilters: Filter[] = [
    {
      field: 'software.packageID',
      values: selectedPackageIds,
    },
  ];

  const extraColumns: ColumnProps<DeviceQueryResult>[] = [
    {
      title: 'Software Found',
      dataIndex: 'device.software',
      key: 'softwareFound',
      render: (_, device: DeviceQueryResult) => {
        if (!isNotNull(device.device) || !isNotNull(device.device.software)) {
          return <span />;
        }
        const matches = device.device.software.filter((sw) =>
          selectedPackageIds.includes(sw.packageID),
        );
        return (
          <span>
            {matches.map((sw, idx) => (
              <div key={idx}>
                {sw.name} {sw.version}
              </div>
            ))}
          </span>
        );
      },
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={() => onAction('refresh', null)}
      title={<ModalTitle>Where Found</ModalTitle>}
      width={'80%'}
      footer={null}
    >
      <p>
        {selectedPackages.map((pkg) => pkg.name).join(', ')} — across all
        organizations.
      </p>
      <InputContainer
        filterConfig={containerConfiguration}
        defaultSort={{
          field: 'device.displayName',
          direction: 'ascend',
        }}
        staticFilters={staticFilters}
      >
        <DevicesContainer
          deviceEndPoint={SOFTWARE_WHERE_FOUND_ENDPOINT}
          deviceFiltersEndPoint={`${DEVICES_CROSS_ORG_PAGINATION_ENDPOINT}/filters`}
        >
          <DeviceOrgTable extraColumns={extraColumns} hideActions />
        </DevicesContainer>
      </InputContainer>
    </Modal>
  );
};

export default DialogSoftwareWhereFound;
